import React from "react";

export default function TermsAndConditionsStep({ setCurrentStep, selectedOffer }) {
  const handleSubmit = () => {
    console.log("Application Submitted!");
    // Move to Final Success Screen
    setCurrentStep(17); 
  };

  // Replace this with your actual logo path from the public folder
  const logoUrl = "/assets/icons/credFin-logo.png"; 

  // Values left intentionally empty to be populated by your backend API
  const kfsData = [
    { label: "Loan amount (sanctioned)", value: "", highlight: false },
    { label: "Processing fee", value: "", highlight: false },
    { label: "GST on processing fee (18%)", value: "", highlight: false },
    { label: "Net amount disbursed", value: "", highlight: true },
    { label: "Interest (1% per day)", value: "", highlight: false },
    { label: "Insurance / other charges", value: "", highlight: false },
    { label: "Total amount repayable", value: "", highlight: true },
    { label: "Annual Percentage Rate (APR)", value: "", highlight: true },
    { label: "Penal / delay charge", value: "", highlight: false },
    { label: "EMI / auto-debit bounce charge", value: "", highlight: false },
    { label: "Tenure", value: "", highlight: false }
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-sans flex flex-col relative pb-[100px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-2 bg-white z-10 sticky top-0">
        <div className="flex justify-center mb-5">
          {/* Logo Implementation */}
          <div className="flex flex-col items-center">
            {/* Fallback to text if image isn't loaded, otherwise show image */}
            <img src={logoUrl} alt="CredFin" className="h-[28px] object-contain mb-1" onError={(e) => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }}/>
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight hidden">CredFin</h1>
            <p className="text-[#979797] text-[8px] font-bold tracking-widest uppercase">
              Loans made Easy
            </p>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <button onClick={() => setCurrentStep(15)} className="w-5 h-5 flex items-center justify-start text-[#4C5564] hover:opacity-70 transition-opacity">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          
          <div className="flex-1 mx-4 h-[4px] bg-[#CCF8E1] rounded-full overflow-hidden">
            <div className="h-full bg-[#12F280] w-[94%] rounded-full"></div>
          </div>
          <span className="text-[9px] text-[#4C5564] font-normal leading-[18px]">94%</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-4 pt-1 flex-1">
        <h2 className="text-[18px] font-[590] text-[#000000] leading-[24px] tracking-tight px-1 mb-1">
          Terms & Conditions
        </h2>
        <p className="text-[13px] text-[#979797] font-normal leading-[16px] px-1 mb-4">
          Key Fact Statement (KFS) / Loan Detail Sheet
        </p>

        {/* Detailed KFS Card - Figma Exact Styles */}
        <div className="border border-[#92D8B4] rounded-[20px] bg-[rgba(146,216,180,0.05)] overflow-hidden">
          
          {/* Top Section */}
          <div className="px-5 pt-6 pb-4">
            <p className="text-[10px] text-[#979797] font-[590] leading-[16px] tracking-[2px] uppercase mb-1">
              RBI-Mandated Disclosure
            </p>
            <h3 className="text-[20px] font-bold text-[#000000] leading-[24px] mb-2">
              Key Fact Statement (KFS)
            </h3>
            <p className="text-[11px] font-[590] text-[#0AAB62] leading-[22px] mb-[-4px]">
              CredFine Digital India Pvt. Ltd.
            </p>
            <p className="text-[11px] text-[#979797] font-normal leading-[22px]">
              CIN U65910WB1997PTC140699
            </p>
          </div>

          <div className="mx-5 border-t border-[#92D8B4]"></div>

          {/* Dynamic Data Rows - Compact Spacing */}
          <div className="px-5 flex flex-col mt-2">
            {kfsData.map((item, index) => (
              <div 
                key={index} 
                className={`py-[10px] ${index !== kfsData.length - 1 ? "border-b border-[rgba(0,0,0,0.1)]" : ""}`}
              >
                <div className="text-[12px] text-[#4C5564] font-normal leading-[16px] mb-[2px]">
                  {item.label}
                </div>
                <div className={`text-[13px] leading-[16px] min-h-[16px] ${item.highlight ? "font-bold text-[#0AAB62]" : "font-[590] text-[#000000]"}`}>
                  {item.value}
                </div>
              </div>
            ))}
          </div>

          {/* Cooling Off Period Box */}
          <div className="px-5 pt-3 pb-6">
            <div className="border border-[rgba(155,159,165,0.2)] rounded-[20px] p-4 bg-white backdrop-blur-[2.5px]">
              <p className="text-[9px] text-[#4C5564] font-normal leading-[13px]">
                <span className="font-[590] text-[#0AAB62]">Cooling-off / look-up period: </span>
                You may exit this loan within 3 days of disbursal by repaying the principal plus the proportionate Annual Percentage Rate (APR) for that period, without any penalty.
              </p>
            </div>
          </div>

          {/* Footer GRO Info */}
          <div className="px-5 pb-6">
            <p className="text-[9px] text-[#4C5564] font-normal leading-[13px]">
              Grievance Redressal Officer (Digital Lending): Amit Kumar Bansal, write to <span className="font-[590] text-[#0AAB62]">grievance@credfine.com</span> or call +91-9008743131. 
              <br/><br/>
              <span className="font-[590] text-[#0AAB62]">CredFine Digital India Pvt. Ltd.</span>, 90 Phears Lane, 3rd Floor, Room No. 303, Kolkata, West Bengal - 700012.
            </p>
          </div>

        </div>
      </div>

      {/* Sticky Bottom Button - Extracted from Figma */}
      <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-gradient-to-t from-white via-white to-transparent px-4 pt-10 pb-6">
        <button 
          onClick={handleSubmit}
          className="w-full bg-[#000000] text-[#FFFFFF] font-normal text-[16px] leading-[19px] rounded-[15px] py-4 flex items-center justify-center active:scale-[0.98] transition-transform shadow-lg shadow-black/10"
        >
          Submit Application
        </button>
      </div>
    </div>
  );
}